import React, { useState, useEffect, useCallback } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Cấu hình icon mặc định của Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const MapPicker = ({ onSelectLocation }) => {
  const [position, setPosition] = useState(null);
  const [center, setCenter] = useState([10.762622, 106.660172]);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const lat = pos.coords.latitude;
          const lng = pos.coords.longitude;
          setCenter([lat, lng]);
          setPosition({ lat, lng });
          const token = "pk.4faa0c3b7c8a6bc556ff075b334abd26";
          const url = `https://us1.locationiq.com/v1/reverse.php?key=${token}&lat=${lat}&lon=${lng}&format=json`;
          fetch(url)
            .then((res) => res.json())
            .then((data) => {
              if (data && data.display_name) {
                onSelectLocation({ lat, lng, address: data.display_name });
              } else {
                alert("Không tìm thấy địa chỉ phù hợp.");
              }
            })
            .catch((error) => {
              console.error("Lỗi reverse geocoding:", error);
              alert("Lỗi khi lấy địa chỉ.");
            });
        },
        (error) => {
          console.error("Lỗi định vị:", error);
        }
      );
    }
  }, [onSelectLocation]);

  function LocationMarker() {
    useMapEvents({
      click(e) {
        const { lat, lng } = e.latlng;
        setPosition({ lat, lng });
        const token = "pk.4faa0c3b7c8a6bc556ff075b334abd26";
        const url = `https://us1.locationiq.com/v1/reverse.php?key=${token}&lat=${lat}&lon=${lng}&format=json`;
        fetch(url)
          .then((res) => res.json())
          .then((data) => {
            if (data && data.display_name) {
              onSelectLocation({ lat, lng, address: data.display_name });
            } else {
              alert("Không tìm thấy địa chỉ phù hợp.");
            }
          })
          .catch((error) => {
            console.error("Lỗi reverse geocoding:", error);
            alert("Lỗi khi lấy địa chỉ.");
          });
      },
    });
    return position ? (
      <Marker position={[position.lat, position.lng]}>
        <Popup>Bạn đã chọn địa điểm này</Popup>
      </Marker>
    ) : null;
  }

  return (
    <MapContainer center={center} zoom={13} style={{ height: "400px", width: "100%" }}>
      <TileLayer
        attribution='© <a href="https://openstreetmapt.org">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <LocationMarker />
    </MapContainer>
  );
};

const EditProfile = () => {
  const { user: authUser, fetchWithRetry, logout, isLoading } = useAuth();
  const [formData, setFormData] = useState({});
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [wards, setWards] = useState([]);
  const [currentLocationText, setCurrentLocationText] = useState("");
  const [showMapModal, setShowMapModal] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const navigate = useNavigate();

  // Kiểm tra authUser và isLoading trước khi render
  useEffect(() => {
    if (!isLoading && !authUser) {
      navigate("/login");
    }
  }, [authUser, isLoading, navigate]);

  // Kiểm tra quyền edit_users
  useEffect(() => {
    if (!isLoading && authUser && !authUser.permissions.includes("edit_users")) {
      setError("Bạn không có quyền chỉnh sửa hồ sơ!");
      setTimeout(() => navigate("/profile"), 2000);
    }
  }, [authUser, isLoading, navigate]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch(
          `http://api.geonames.org/countryInfoJSON?username=chitkenlove`
        );
        const data = await response.json();
        if (data.geonames) {
          setCountries(data.geonames);
        } else {
          console.error("Dữ liệu trả về không hợp lệ:", data);
        }
      } catch (error) {
        console.error("Lỗi tải danh sách quốc gia:", error);
      }
    };
    fetchCountries();
  }, []);

  useEffect(() => {
    if (selectedCountry) {
      const fetchCities = async () => {
        try {
          const response = await fetch(
            `http://api.geonames.org/childrenJSON?geonameId=${selectedCountry.geonameId}&username=chitkenlove`
          );
          const data = await response.json();
          if (data.geonames) {
            setCities(data.geonames);
          } else {
            console.error("Dữ liệu trả về không hợp lệ:", data);
          }
        } catch (error) {
          console.error("Lỗi tải danh sách thành phố:", error);
        }
      };
      fetchCities();
    }
  }, [selectedCountry]);

  useEffect(() => {
    if (selectedCity) {
      const fetchDistricts = async () => {
        try {
          const response = await fetch(
            `http://api.geonames.org/childrenJSON?geonameId=${selectedCity.geonameId}&username=chitkenlove`
          );
          const data = await response.json();
          if (data.geonames) {
            setDistricts(data.geonames);
          } else {
            console.error("Dữ liệu trả về không hợp lệ:", data);
          }
        } catch (error) {
          console.error("Lỗi tải danh sách quận/huyện:", error);
        }
      };
      fetchDistricts();
    }
  }, [selectedCity]);

  useEffect(() => {
    if (selectedDistrict) {
      const fetchWards = async () => {
        try {
          const response = await fetch(
            `http://api.geonames.org/childrenJSON?geonameId=${selectedDistrict.geonameId}&username=chitkenlove`
          );
          const data = await response.json();
          if (data.geonames) {
            setWards(data.geonames);
          } else {
            console.error("Dữ liệu trả về không hợp lệ:", data);
          }
        } catch (error) {
          console.error("Lỗi tải danh sách xã/phường:", error);
        }
      };
      fetchWards();
    }
  }, [selectedDistrict]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleNestedChange = (e, parentKey) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [parentKey]: {
        ...formData[parentKey],
        [name]: value,
      },
    });
  };

  const handleSelectLocation = useCallback(
    async (location) => {
      const { lat, lng, address } = location;
      setCurrentLocationText(address);
      try {
        const response = await fetchWithRetry({
          method: "put",
          url: "/api/users/location",
          data: { latitude: lat, longitude: lng },
        });
        const updatedLocation = response.data.currentLocation;
        if (!updatedLocation || !updatedLocation.city) {
          throw new Error("Phản hồi từ API không chứa dữ liệu currentLocation hợp lệ.");
        }
        setFormData((prev) => ({
          ...prev,
          currentLocation: {
            type: "Point",
            coordinates: [lng, lat],
            country: updatedLocation.country || "",
            city: updatedLocation.city || "",
            district: updatedLocation.district || "",
            ward: updatedLocation.ward || "",
          },
        }));
        setShowMapModal(false);
      } catch (error) {
        console.error("Lỗi khi cập nhật chỗ ở:", error);
        if (error.response?.status === 401) {
          setError("Phiên làm việc hết hạn. Vui lòng đăng nhập lại.");
          setTimeout(() => logout(), 2000);
        } else if (error.response?.status === 403) {
          setError("Bạn không có quyền cập nhật vị trí! Vui lòng liên hệ quản trị viên.");
          setTimeout(() => navigate("/profile"), 2000);
        } else if (error.response?.status === 404) {
          setError("Không tìm thấy người dùng hoặc API không tồn tại. Vui lòng liên hệ quản trị viên.");
        } else {
          setError(error.response?.data?.message || "Không thể cập nhật chỗ ở. Vui lòng thử lại.");
        }
      }
    },
    [fetchWithRetry, logout, navigate]
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    try {
      const updatedData = {
        name: formData.name,
        email: formData.email,
        username: formData.username,
        dateOfBirth: formData.dateOfBirth,
        gender: formData.gender,
        bio: formData.bio,
        willingToRelocate: formData.willingToRelocate,
        zodiacSign: formData.zodiacSign,
        lunarYear: formData.lunarYear,
        locationText: {
          country: formData.locationText?.country || "",
          city: formData.locationText?.city || "",
          district: formData.locationText?.district || "",
          ward: formData.locationText?.ward || "",
        },
        currentLocation: formData.currentLocation || {
          type: "Point",
          coordinates: [0, 0],
          country: "",
          city: "",
          district: "",
          ward: "",
        },
        appearance: formData.appearance || {
          hairColor: "",
          eyeColor: "",
          height: 0,
          weight: 0,
          bodyType: "average",
          ethnicity: "",
          bodyArt: "",
          appearanceRating: "",
        },
        lifestyle: formData.lifestyle || {
          drinking: "no",
          smoking: "no",
          maritalStatus: "single",
          hasChildren: false,
          numberOfChildren: 0,
          oldestChild: "",
          youngestChild: "",
          wantsChildren: "not_sure",
          hasPets: "",
          occupation: "",
          income: "",
        },
        culture: formData.culture || {
          nationality: "",
          education: "",
          languages: [],
          primaryLanguage: "",
          englishAbility: "",
          vietnameseAbility: "",
          religion: "",
        },
      };

      const response = await fetchWithRetry({
        method: "put",
        url: "/api/users/profile",
        data: updatedData,
      });

      if (response.status === 200 && response.data?.user) {
        const updatedUser = response.data.user;
        if (updatedUser.currentLocation?.city) {
          const fullAddress = [
            updatedUser.currentLocation.ward,
            updatedUser.currentLocation.district,
            updatedUser.currentLocation.city,
            updatedUser.currentLocation.country,
          ]
            .filter(Boolean)
            .join(", ");
          setCurrentLocationText(fullAddress);
        }
        setSuccess("Cập nhật hồ sơ thành công!");
        setTimeout(() => navigate("/profile"), 2000);
      } else {
        setError("Cập nhật không thành công! Vui lòng thử lại.");
      }
    } catch (error) {
      console.error("Lỗi cập nhật hồ sơ:", error);
      if (error.response?.status === 401) {
        setError("Phiên làm việc hết hạn. Vui lòng đăng nhập lại.");
        setTimeout(() => logout(), 2000);
      } else if (error.response?.status === 403) {
        setError("Bạn không có quyền chỉnh sửa hồ sơ! Vui lòng liên hệ quản trị viên.");
        setTimeout(() => navigate("/profile"), 2000);
      } else if (error.response?.status === 400) {
        setError(error.response.data.message || "Dữ liệu không hợp lệ. Vui lòng kiểm tra lại.");
      } else {
        setError(error.response?.data?.message || "Không thể cập nhật hồ sơ. Vui lòng thử lại.");
      }
    }
  };

  useEffect(() => {
    if (authUser) {
      setFormData(authUser);
      if (authUser.currentLocation?.city) {
        const fullAddress = [
          authUser.currentLocation.ward,
          authUser.currentLocation.district,
          authUser.currentLocation.city,
          authUser.currentLocation.country,
        ]
          .filter(Boolean)
          .join(", ");
        setCurrentLocationText(fullAddress);
      }
    }
  }, [authUser]);

  if (isLoading) {
    return <p className="text-center text-gray-600">Đang tải...</p>;
  }

  if (!authUser) {
    return null; // ProtectedRoute sẽ xử lý chuyển hướng
  }

  if (!authUser.permissions.includes("edit_users")) {
    return (
      <div className="font-sans min-h-screen bg-gray-100 p-6">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">Chỉnh Sửa Hồ Sơ</h2>
        <p className="text-red-500 text-center mb-4">
          Bạn không có quyền chỉnh sửa hồ sơ! Vui lòng liên hệ quản trị viên.
        </p>
        <div className="flex justify-center">
          <button
            onClick={() => navigate("/profile")}
            className="px-6 py-2 bg-gray-500 text-white rounded-lg shadow hover:bg-gray-600"
          >
            Quay lại
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="font-sans min-h-screen bg-gray-100 p-6">
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">Chỉnh Sửa Hồ Sơ</h2>

      {error && <p className="text-red-500 text-center mb-4">{error}</p>}
      {success && <p className="text-green-500 text-center mb-4">{success}</p>}

      <form onSubmit={handleSubmit} className="mt-6 space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <label className="block">
            Tên:
            <input
              type="text"
              name="name"
              value={formData.name || ""}
              onChange={handleChange}
              className="w-full border p-2 rounded shadow-sm"
              required
            />
          </label>
          <label className="block">
            Email:
            <input
              type="email"
              name="email"
              value={formData.email || ""}
              onChange={handleChange}
              className="w-full border p-2 rounded shadow-sm"
              required
            />
          </label>
          <label className="block">
            Ngày sinh:
            <input
              type="date"
              name="dateOfBirth"
              value={
                formData.dateOfBirth
                  ? new Date(formData.dateOfBirth).toISOString().split("T")[0]
                  : ""
              }
              onChange={handleChange}
              className="w-full border p-2 rounded shadow-sm"
              required
            />
          </label>
          <label className="block">
            Giới tính:
            <select
              name="gender"
              value={formData.gender || "other"}
              onChange={handleChange}
              className="w-full border p-2 rounded shadow-sm"
              required
            >
              <option value="male">Nam</option>
              <option value="female">Nữ</option>
              <option value="other">Khác</option>
            </select>
          </label>
          <label className="block">
            Sẵn sàng di chuyển:
            <select
              name="willingToRelocate"
              value={formData.willingToRelocate || "no"}
              onChange={handleChange}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="yes">Có</option>
              <option value="no">Không</option>
            </select>
          </label>
          <label className="block">
            Chòm sao:
            <select
              name="zodiacSign"
              value={formData.zodiacSign || ""}
              onChange={handleChange}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="">Không chọn</option>
              <option value="Bò Cạp">Bò Cạp</option>
              <option value="Bảo Bình">Bảo Bình</option>
              <option value="Cự Giải">Cự Giải</option>
              <option value="Dương Cưu">Dương Cưu</option>
              <option value="Kim Ngưu">Kim Ngưu</option>
              <option value="Ma Kết">Ma Kết</option>
              <option value="Nhân Mã">Nhân Mã</option>
              <option value="Song Ngư">Song Ngư</option>
              <option value="Song Sinh">Song Sinh</option>
              <option value="Sư Tử">Sư Tử</option>
              <option value="Thiên Bình">Thiên Bình</option>
              <option value="Xử Nữ">Xử Nữ</option>
              <option value="Không biết">Không biết</option>
            </select>
          </label>
          <label className="block">
            Năm sinh âm lịch:
            <select
              name="lunarYear"
              value={formData.lunarYear || ""}
              onChange={handleChange}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="">Không chọn</option>
              <option value="Dần">Dần</option>
              <option value="Dậu">Dậu</option>
              <option value="Hợi">Hợi</option>
              <option value="Mão">Mão</option>
              <option value="Mùi">Mùi</option>
              <option value="Ngọ">Ngọ</option>
              <option value="Sửu">Sửu</option>
              <option value="Thân">Thân</option>
              <option value="Thìn">Thìn</option>
              <option value="Tuất">Tuất</option>
              <option value="Tý">Tý</option>
              <option value="Tỵ">Tỵ</option>
              <option value="Không biết">Không biết</option>
            </select>
          </label>
          <label className="block">
            Quốc gia:
            <input
              type="text"
              name="country"
              value={formData.locationText?.country || ""}
              onChange={(e) => {
                const value = e.target.value;
                setFormData({
                  ...formData,
                  locationText: { ...formData.locationText, country: value },
                });
                const found = countries.find((c) => c.countryName.toLowerCase() === value.toLowerCase());
                if (found) setSelectedCountry(found);
                else {
                  setSelectedCountry(null);
                  setCities([]);
                  setDistricts([]);
                  setWards([]);
                }
              }}
              list="countryList"
              placeholder="Nhập hoặc chọn quốc gia"
              className="w-full border p-2 rounded shadow-sm"
              required
            />
            <datalist id="countryList">
              {countries.map((country) => (
                <option key={country.countryCode} value={country.countryName} />
              ))}
            </datalist>
          </label>
          <label className="block">
            Thành phố:
            <input
              type="text"
              name="city"
              value={formData.locationText?.city || ""}
              onChange={(e) => {
                const value = e.target.value;
                setFormData({
                  ...formData,
                  locationText: { ...formData.locationText, city: value },
                });
                const found = cities.find((c) => c.name.toLowerCase() === value.toLowerCase());
                if (found) setSelectedCity(found);
                else {
                  setSelectedCity(null);
                  setDistricts([]);
                  setWards([]);
                }
              }}
              list="cityList"
              placeholder="Nhập hoặc chọn thành phố"
              className="w-full border p-2 rounded shadow-sm"
              required
            />
            <datalist id="cityList">
              {cities.map((city) => (
                <option key={city.geonameId} value={city.name} />
              ))}
            </datalist>
          </label>
          <label className="block">
            Quận/Huyện:
            <input
              type="text"
              name="district"
              value={formData.locationText?.district || ""}
              onChange={(e) => {
                const value = e.target.value;
                setFormData({
                  ...formData,
                  locationText: { ...formData.locationText, district: value },
                });
                const found = districts.find((d) => d.name.toLowerCase() === value.toLowerCase());
                if (found) setSelectedDistrict(found);
                else {
                  setSelectedDistrict(null);
                  setWards([]);
                }
              }}
              list="districtList"
              placeholder="Nhập hoặc chọn quận/huyện"
              className="w-full border p-2 rounded shadow-sm"
              required
            />
            <datalist id="districtList">
              {districts.map((district) => (
                <option key={district.geonameId} value={district.name} />
              ))}
            </datalist>
          </label>
          <label className="block">
            Xã/Phường:
            <input
              type="text"
              name="ward"
              value={formData.locationText?.ward || ""}
              onChange={(e) => {
                const value = e.target.value;
                setFormData({
                  ...formData,
                  locationText: { ...formData.locationText, ward: value },
                });
              }}
              list="wardList"
              placeholder="Nhập hoặc chọn xã/phường"
              className="w-full border p-2 rounded shadow-sm"
              required
            />
            <datalist id="wardList">
              {wards.map((ward) => (
                <option key={ward.geonameId} value={ward.name} />
              ))}
            </datalist>
          </label>
          <label className="block">
            Chỗ ở hiện tại:
            <input
              type="text"
              value={currentLocationText}
              onChange={(e) => setCurrentLocationText(e.target.value)}
              placeholder="Nhấp 'Chọn vị trí' hoặc nhập tay"
              className="w-full border p-2 rounded shadow-sm"
            />
            <button
              type="button"
              onClick={() => setShowMapModal(true)}
              className="bg-blue-500 text-white px-3 py-1 rounded mt-2"
            >
              Chọn vị trí
            </button>
          </label>
          <label className="block">
            Chiều cao (cm):
            <input
              type="number"
              name="height"
              value={formData.appearance?.height || ""}
              onChange={(e) => handleNestedChange(e, "appearance")}
              className="w-full border p-2 rounded shadow-sm"
              min="0"
              max="300"
            />
          </label>
          <label className="block">
            Cân nặng (kg):
            <input
              type="number"
              name="weight"
              value={formData.appearance?.weight || ""}
              onChange={(e) => handleNestedChange(e, "appearance")}
              className="w-full border p-2 rounded shadow-sm"
              min="0"
              max="300"
            />
          </label>
          <label className="block">
            Màu tóc:
            <select
              name="hairColor"
              value={formData.appearance?.hairColor || ""}
              onChange={(e) => handleNestedChange(e, "appearance")}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="">Không chọn</option>
              <option value="Hói / Cạo">Hói / Cạo</option>
              <option value="Nâu">Nâu</option>
              <option value="Nâu sáng">Nâu sáng</option>
              <option value="Vàng">Vàng</option>
              <option value="Xám / Trắng">Xám / Trắng</option>
              <option value="Đen">Đen</option>
              <option value="Đỏ">Đỏ</option>
              <option value="Thường xuyên thay đổi">Thường xuyên thay đổi</option>
            </select>
          </label>
          <label className="block">
            Màu mắt:
            <select
              name="eyeColor"
              value={formData.appearance?.eyeColor || ""}
              onChange={(e) => handleNestedChange(e, "appearance")}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="">Không chọn</option>
              <option value="Nâu">Nâu</option>
              <option value="Nâu lục nhạt">Nâu lục nhạt</option>
              <option value="Xanh lam">Xanh lam</option>
              <option value="Xanh lục">Xanh lục</option>
              <option value="Xám">Xám</option>
            </select>
          </label>
          <label className="block">
            Thân hình:
            <select
              name="bodyType"
              value={formData.appearance?.bodyType || "average"}
              onChange={(e) => handleNestedChange(e, "appearance")}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="average">Trung bình</option>
              <option value="slim">Gầy</option>
              <option value="athletic">Lực lưỡng</option>
              <option value="heavy">Nặng ký</option>
            </select>
          </label>
          <label className="block">
            Sắc tộc:
            <select
              name="ethnicity"
              value={formData.appearance?.ethnicity || ""}
              onChange={(e) => handleNestedChange(e, "appearance")}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="">Không chọn</option>
              <option value="Châu Á">Châu Á</option>
              <option value="Da trắng">Da trắng</option>
              <option value="La tinh">La tinh</option>
              <option value="Lai">Lai</option>
              <option value="Phi">Phi</option>
              <option value="Thái Bình Dương">Thái Bình Dương</option>
              <option value="Ả rập (Trung Đông)">Ả rập (Trung Đông)</option>
              <option value="Ấn Độ">Ấn Độ</option>
              <option value="Khác">Khác</option>
              <option value="Không thích nói">Không thích nói</option>
            </select>
          </label>
          <label className="block">
            Hình xăm/Khuyên:
            <select
              name="bodyArt"
              value={formData.appearance?.bodyArt || ""}
              onChange={(e) => handleNestedChange(e, "appearance")}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="">Không chọn</option>
              <option value="Hình xăm">Hình xăm</option>
              <option value="Khuyên">Khuyên</option>
              <option value="Khuyên tai">Khuyên tai</option>
              <option value="Đóng dấu">Đóng dấu</option>
              <option value="Khác">Khác</option>
              <option value="Không">Không</option>
              <option value="Không thích nói">Không thích nói</option>
            </select>
          </label>
          <label className="block">
            Đánh giá diện mạo:
            <select
              name="appearanceRating"
              value={formData.appearance?.appearanceRating || ""}
              onChange={(e) => handleNestedChange(e, "appearance")}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="">Không chọn</option>
              <option value="Dưới mức trung bình">Dưới mức trung bình</option>
              <option value="Trung bình">Trung bình</option>
              <option value="Thu hút">Thu hút</option>
              <option value="Rất thu hút">Rất thu hút</option>
            </select>
          </label>
          <label className="block">
            Uống rượu:
            <select
              name="drinking"
              value={formData.lifestyle?.drinking || "no"}
              onChange={(e) => handleNestedChange(e, "lifestyle")}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="no">Không</option>
              <option value="yes">Có</option>
              <option value="occasionally">Thỉnh thoảng</option>
            </select>
          </label>
          <label className="block">
            Hút thuốc:
            <select
              name="smoking"
              value={formData.lifestyle?.smoking || "no"}
              onChange={(e) => handleNestedChange(e, "lifestyle")}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="no">Không</option>
              <option value="yes">Có</option>
              <option value="occasionally">Thỉnh thoảng</option>
            </select>
          </label>
          <label className="block">
            Tình trạng hôn nhân:
            <select
              name="maritalStatus"
              value={formData.lifestyle?.maritalStatus || "single"}
              onChange={(e) => handleNestedChange(e, "lifestyle")}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="single">Độc thân</option>
              <option value="married">Đã kết hôn</option>
              <option value="divorced">Ly hôn</option>
              <option value="widowed">Góa</option>
              <option value="other">Khác</option>
            </select>
          </label>
          <label className="block">
            Có con:
            <select
              name="hasChildren"
              value={formData.lifestyle?.hasChildren ? "true" : "false"}
              onChange={(e) => handleNestedChange(e, "lifestyle")}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="false">Không</option>
              <option value="true">Có</option>
            </select>
          </label>
          <label className="block">
            Số lượng con:
            <input
              type="number"
              name="numberOfChildren"
              value={formData.lifestyle?.numberOfChildren || 0}
              onChange={(e) => handleNestedChange(e, "lifestyle")}
              className="w-full border p-2 rounded shadow-sm"
              min="0"
            />
          </label>
          <label className="block">
            Con lớn nhất:
            <select
              name="oldestChild"
              value={formData.lifestyle?.oldestChild || ""}
              onChange={(e) => handleNestedChange(e, "lifestyle")}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="">Không chọn</option>
              <option value="0-5">0-5 tuổi</option>
              <option value="6-10">6-10 tuổi</option>
              <option value="11-15">11-15 tuổi</option>
              <option value="16-20">16-20 tuổi</option>
              <option value="21+">21 tuổi trở lên</option>
            </select>
          </label>
          <label className="block">
            Con nhỏ nhất:
            <select
              name="youngestChild"
              value={formData.lifestyle?.youngestChild || ""}
              onChange={(e) => handleNestedChange(e, "lifestyle")}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="">Không chọn</option>
              <option value="0-5">0-5 tuổi</option>
              <option value="6-10">6-10 tuổi</option>
              <option value="11-15">11-15 tuổi</option>
              <option value="16-20">16-20 tuổi</option>
              <option value="21+">21 tuổi trở lên</option>
            </select>
          </label>
          <label className="block">
            Muốn có (thêm) con:
            <select
              name="wantsChildren"
              value={formData.lifestyle?.wantsChildren || "not_sure"}
              onChange={(e) => handleNestedChange(e, "lifestyle")}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="yes">Có</option>
              <option value="no">Không</option>
              <option value="not_sure">Không chắc</option>
            </select>
          </label>
          <label className="block">
            Có vật nuôi:
            <select
              name="hasPets"
              value={formData.lifestyle?.hasPets || ""}
              onChange={(e) => handleNestedChange(e, "lifestyle")}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="">Không chọn</option>
              <option value="Bò sát">Bò sát</option>
              <option value="Chim chóc">Chim chóc</option>
              <option value="Chó">Chó</option>
              <option value="Cá">Cá</option>
              <option value="Hamster">Hamster</option>
              <option value="Mèo">Mèo</option>
              <option value="Ngựa">Ngựa</option>
              <option value="Thú quý hiếm">Thú quý hiếm</option>
              <option value="Thỏ">Thỏ</option>
              <option value="Khác">Khác</option>
              <option value="Không có vật nuôi">Không có vật nuôi</option>
              <option value="Không thích nói">Không thích nói</option>
            </select>
          </label>
          <label className="block">
            Nghề nghiệp:
            <select
              name="occupation"
              value={formData.lifestyle?.occupation || ""}
              onChange={(e) => handleNestedChange(e, "lifestyle")}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="">Không chọn</option>
              <option value="Bán hàng / Tiếp thị">Bán hàng / Tiếp thị</option>
              <option value="Chữa cháy / Hành pháp / Bảo vệ">Chữa cháy / Hành pháp / Bảo vệ</option>
              <option value="Giao thông vận tải">Giao thông vận tải</option>
              <option value="Hành chính / Thư ký">Hành chính / Thư ký</option>
              <option value="Làm về pháp luật">Làm về pháp luật</option>
              <option value="Người giúp việc">Người giúp việc</option>
              <option value="Phi lợi nhuận / Giáo sĩ / Công tác xã hội">Phi lợi nhuận / Giáo sĩ / Công tác xã hội</option>
              <option value="Sinh viên">Sinh viên</option>
              <option value="Bán lẻ / Dịch vụ thực phẩm">Bán lẻ / Dịch vụ thực phẩm</option>
              <option value="Công nghệ thông tin / Truyền thông">Công nghệ thông tin / Truyền thông</option>
              <option value="Giáo dục">Giáo dục</option>
              <option value="Không có việc làm / Ở nhà">Không có việc làm / Ở nhà</option>
              <option value="Nghệ thuật / Sáng tạo / Biểu diễn">Nghệ thuật / Sáng tạo / Biểu diễn</option>
              <option value="Người lao động / Công nhân nhà máy">Người lao động / Công nhân nhà máy</option>
              <option value="Quân đội">Quân đội</option>
              <option value="Thể thao / Giải trí">Thể thao / Giải trí</option>
              <option value="Chính trị / Nhà nước / Dịch vụ dân sự">Chính trị / Nhà nước / Dịch vụ dân sự</option>
              <option value="Du lịch / Khách sạn">Du lịch / Khách sạn</option>
              <option value="Giải trí / Truyền thông">Giải trí / Truyền thông</option>
              <option value="Kỹ thuật / Khoa học / Kỹ sư">Kỹ thuật / Khoa học / Kỹ sư</option>
              <option value="Nghỉ hưu">Nghỉ hưu</option>
              <option value="Nông nghiệp">Nông nghiệp</option>
              <option value="Quảng cáo / Truyền thông">Quảng cáo / Truyền thông</option>
              <option value="Thợ cắt tóc">Thợ cắt tóc</option>
              <option value="Trông trẻ">Trông trẻ</option>
              <option value="Tài chính / Ngân hàng / Tự kinh doanh">Tài chính / Ngân hàng / Tự kinh doanh</option>
              <option value="Xây dựng / Giao dịch">Xây dựng / Giao dịch</option>
              <option value="Y khoa / Nha khoa / Thú y">Y khoa / Nha khoa / Thú y</option>
            </select>
          </label>
          <label className="block">
            Thu nhập:
            <select
              name="income"
              value={formData.lifestyle?.income || ""}
              onChange={(e) => handleNestedChange(e, "lifestyle")}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="">Không chọn</option>
              <option value="Dưới 5 triệu">Dưới 5 triệu</option>
              <option value="5-10 triệu">5-10 triệu</option>
              <option value="10-20 triệu">10-20 triệu</option>
              <option value="20-50 triệu">20-50 triệu</option>
              <option value="Trên 50 triệu">Trên 50 triệu</option>
              <option value="Không thích nói">Không thích nói</option>
            </select>
          </label>
          <label className="block">
            Quốc tịch:
            <input
              type="text"
              name="nationality"
              value={formData.culture?.nationality || ""}
              onChange={(e) => handleNestedChange(e, "culture")}
              className="w-full border p-2 rounded shadow-sm"
            />
          </label>
          <label className="block">
            Trình độ văn hóa:
            <select
              name="education"
              value={formData.culture?.education || ""}
              onChange={(e) => handleNestedChange(e, "culture")}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="">Không chọn</option>
              <option value="Cấp 1">Cấp 1</option>
              <option value="Bằng cấp 3 / Cấp 2">Bằng cấp 3 / Cấp 2</option>
              <option value="Bằng trung học phổ thông">Bằng trung học phổ thông</option>
              <option value="Bằng trung cấp nghề">Bằng trung cấp nghề</option>
              <option value="Bằng cử nhân">Bằng cử nhân</option>
              <option value="Bằng thạc sỹ">Bằng thạc sỹ</option>
              <option value="Tiến sĩ">Tiến sĩ</option>
            </select>
          </label>
          <label className="block">
            Ngôn ngữ chính:
            <select
              name="primaryLanguage"
              value={formData.culture?.primaryLanguage || ""}
              onChange={(e) => handleNestedChange(e, "culture")}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="">Không chọn</option>
              <option value="Tiếng Việt">Tiếng Việt</option>
              <option value="Tiếng Anh">Tiếng Anh</option>
              <option value="Chinese (Mandarin)">Chinese (Mandarin)</option>
              <option value="Tiếng Pháp">Tiếng Pháp</option>
            </select>
          </label>
          <label className="block">
            Khả năng tiếng Anh:
            <select
              name="englishAbility"
              value={formData.culture?.englishAbility || ""}
              onChange={(e) => handleNestedChange(e, "culture")}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="">Không chọn</option>
              <option value="Không">Không</option>
              <option value="Thỉnh thoảng">Thỉnh thoảng</option>
              <option value="Tốt">Tốt</option>
              <option value="Rất tốt">Rất tốt</option>
              <option value="Lưu loát">Lưu loát</option>
            </select>
          </label>
          <label className="block">
            Khả năng tiếng Việt:
            <select
              name="vietnameseAbility"
              value={formData.culture?.vietnameseAbility || ""}
              onChange={(e) => handleNestedChange(e, "culture")}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="">Không chọn</option>
              <option value="Không">Không</option>
              <option value="Thỉnh thoảng">Thỉnh thoảng</option>
              <option value="Tốt">Tốt</option>
              <option value="Rất tốt">Rất tốt</option>
              <option value="Lưu loát">Lưu loát</option>
            </select>
          </label>
          <label className="block">
            Ngôn ngữ:
            <input
              type="text"
              name="languages"
              value={formData.culture?.languages?.join(", ") || ""}
              onChange={(e) =>
                handleNestedChange(
                  { target: { name: "languages", value: e.target.value.split(", ") } },
                  "culture"
                )
              }
              className="w-full border p-2 rounded shadow-sm"
              placeholder="Nhập các ngôn ngữ, cách nhau bởi dấu phẩy"
            />
          </label>
          <label className="block">
            Tôn giáo:
            <select
              name="religion"
              value={formData.culture?.religion || ""}
              onChange={(e) => handleNestedChange(e, "culture")}
              className="w-full border p-2 rounded shadow-sm"
            >
              <option value="">Không chọn</option>
              <option value="Phật giáo">Phật giáo</option>
              <option value="Thiên Chúa giáo">Thiên Chúa giáo</option>
              <option value="Hồi giáo">Hồi giáo</option>
              <option value="Đạo giáo">Đạo giáo</option>
              <option value="Tích-khắc giáo">Tích-khắc giáo</option>
              <option value="Đạo Shintō">Đạo Shintō</option>
              <option value="Không có đạo">Không có đạo</option>
              <option value="Không thích nói">Không thích nói</option>
            </select>
          </label>
          <label className="block col-span-2">
            Tiểu sử:
            <textarea
              name="bio"
              value={formData.bio || ""}
              onChange={handleChange}
              className="w-full border p-2 rounded shadow-sm"
            />
          </label>
        </div>
        <div className="flex justify-center gap-4">
          <button
            type="submit"
            className="px-6 py-2 bg-green-500 text-white rounded-lg shadow hover:bg-green-600"
          >
            Lưu thay đổi
          </button>
          <button
            type="button"
            onClick={() => navigate("/profile")}
            className="px-6 py-2 bg-gray-500 text-white rounded-lg shadow hover:bg-gray-600"
          >
            Hủy
          </button>
        </div>
      </form>

      {showMapModal && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            className="modal-content"
            style={{
              width: "80%",
              height: "80%",
              background: "#fff",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <MapPicker onSelectLocation={handleSelectLocation} />
            <button
              onClick={() => setShowMapModal(false)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                padding: "8px 12px",
                background: "#ff4444",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                zIndex: 10000,
                boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
              }}
            >
              Đóng
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditProfile;